import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-8 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于红桃影院综艺在线观看的常见疑问
        </p>
        <div className="flex flex-col gap-4">
          {faqData.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer"
              open={faq.id === 1}
            >
              <summary className="flex items-center justify-between px-6 py-5 text-sm font-semibold text-foreground-800 list-none">
                <span>{faq.question}</span>
                <span className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform flex-shrink-0 ml-3">
                  <i className="ri-add-line text-foreground-600 text-xs"></i>
                </span>
              </summary>
              <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}